<template>
  <div class="container">
    <Navbar />
    <DirectorNavbar />
    <router-view class="vistas" />
  </div>
</template>

<script>
import Navbar from "@/components/navbar.vue";
import DirectorNavbar from "@/components/DirectorNavbar.vue";

export default {
  name: "App",
  components: {
    Navbar,
    DirectorNavbar,
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  width: 100%;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}
.vistas {
  margin-top: 9vh;
}
</style>
